const MOCK_DRIVER_LOCATION = {
  latitude: 10.774017,
  longitude: 106.701639,
  heading: 30, // 旋转角度, 0车头朝上
};

const MOCK_SHIP_CUSTOMER_DATA_NEW = {
  'code': '241122SM16R8',
  'payment_method': {
    'payment_method_name': 'Tiền mặt',
    'payment_method_id': 1,
  },
  'booking_service_type': 1,
  'customer_note': '',
  'create_time': 1732257616,
  'pick_time': 1732258200,
  'data_by_status': {
    'is_share_booking': false,
    'is_report': false,
    'cancel_reason': '<b>Lý do trả hàng: </b>Không thể giao hàng cho người nhận.',
    'is_user_cancel': false,
    'is_refund': false,
    'display_statuses': [
      {
        'status': 2,
        'style_type': 1,
        'update_time': 1732257616,
        'is_expected_time': false,
        'status_name': 'Đặt đơn',
      },
      {
        'status': 3,
        'style_type': 1,
        'update_time': 1732257682,
        'is_expected_time': false,
        'status_name': 'Đã lấy',
      },
      {
        'status': 5,
        'style_type': 3,
        'update_time': 1732257698,
        'is_expected_time': false,
        'status_name': 'Đã hủy',
      },
    ],
    'is_chat_accessible': false,
    'heading_status': 'Đơn hàng hủy',
    'is_end_status': true,
    'expected_times': [
      {
        'style_type': 1,
        'is_expected_time': false,
        'name': 'Đã lấy',
        'time': 1732257682,
      },
      {
        'style_type': 1,
        'is_expected_time': true,
        'name': 'Đã huỷ đơn lúc',
        'time': 1732257698,
      },
    ],
    'is_pickup_help': false,
    'system_note': 'Lưu ý: Đơn hàng đã được trả lại thành công cho bạn. Phí trả hàng <b>4.000đ</b> đã được thanh toán.',
    'is_feedback': true,
  },
  'pick_real_time': 1732257682,
  'return_time': 1732257698,
  'pick_type': 1,
  'item_value': {
    'raw_value': 0.0,
    'value': 0.0,
    'text': '0đ',
  },
  'sender_bill': {
    'total': {
      'raw_value': 7800.0,
      'value': 7800.0,
      'text': '7.800đ',
    },
    'bill_items': [
      {
        'raw_value': 7750.0,
        'fee_type': 1,
        'name': 'Phí giao hàng (1.4km)',
        'value': 7750.0,
        'text': '7.750đ',
      },
      {
        'raw_value': 50.0,
        'description': 'Phí dịch vụ được áp dụng trên đơn để giúp ShopeeFood tiếp tục cải thiện dịch vụ và mang lại cho khách hàng trải nghiệm tốt nhất!',
        'text': '50đ',
        'value': 50.0,
        'fee_type': 5,
        'name': 'Phí dịch vụ',
      },
    ],
  },
  'paid_status': 2,
  'shipping_fee_origin': {
    'raw_value': 7707,
    'value': 8000.0,
    'text': '8.000đ',
  },
  'item_info': {
    'item_category_id': 2,
    'item_weight': 1,
  },
  'shipping_fee_discount': {
    'raw_value': 0,
    'value': 0,
    'text': '0đ',
  },
  'return_fee': {
    'return_fee_payment_method': 1,
    'raw_value': 4000.0,
    'value': 4000.0,
    'text': '4.000đ',
  },
  'drop_real_time': 1732257698,
  'target_user_type': 1,
  'assigning_timeout_time': 1732261216,
  'status': 15,
  'cancel_time': null,
  'update_time': 1732257698,
  'sender_info': {
    'phone': '+002024082601',
    'user_contact_id': 0,
    'bill_amount': -7800.0,
    'name': 'foodee_6jck16qb',
  },
  'booking_sharing_url': 'https://share.test.now.vn/ship/241122SM16R8bf3fe',
  'drop_address_info': {
    'latitude': 10.760368,
    'city_id': 217,
    'district_id': 6,
    'longitude': 106.700455,
    'address': 'Hoàng Diệu, Phường 6, Quận 4, TP. Hồ Chí Minh, Việt Nam',
  },
  'driver': {
    'status': 1,
    'last_name': 'yaqi',
    'uid': 50000135,
    'type_id': 11,
    'city_id': 217,
    'driver_statistics': {
      'started_working_time': 1716940800,
      'total_trip': 33,
      'average_rate': 4.5,
      'total_distance': 117088,
      'rating_reasons': [
        {
          'reason_id': 163,
          'total_rate': 1,
        },
        {
          'reason_id': 201,
          'total_rate': 1,
        },
      ],
    },
    'license_plate': '59U1-77770',
    'created_time': '2024-05-29 13:58:18',
    'avatar_mms_img_id': 'vn-11134521-7r98o-m22b92iv76cnb3',
    'full_name': 'yaqi li',
    'skype': '',
    'max_order_handle': -1,
    'first_name': 'li',
    'display_name': 'yaqi li',
    'personal_email': 'yaqi.li@shopee.com',
    'work_status_id': 1,
    'secondary_phone': '',
    'other_phones': [],
    'email': 'yaqi.li@qq.com',
    'username': 'yaqi li',
    'vehicle_description': 'Air Blade',
    'image_name': 'vn-11134521-7r98o-m22b92iv76cnb3',
    'group_service': 1,
    'phone': '0059602039',
    'is_online': true,
    'working_city_id': 217,
    'begin_work_date': '2024-05-29 00:00:00',
    'is_deleted': false,
    'name': 'yaqi li',
    'avatars': [
      {
        'width': 200,
        'value': 'https://down-ws-vn.img.susercontent.com/vn-11134521-7r98o-m22b92iv76cnb3',
        'height': 200,
      },
    ],
    'avatar_url': 'https://down-ws-vn.img.susercontent.com/vn-11134521-7r98o-m22b92iv76cnb3',
    'avatar': 'https://down-ws-vn.img.susercontent.com/vn-11134521-7r98o-m22b92iv76cnb3',
  },
  'shipper_id': 50000135,
  'help_center_url': 'https://help.shopeefood.vn/s/article/Khi-n%C3%A0o-t%C3%B4i-nh%E1%BA%ADn-%C4%91%C6%B0%E1%BB%A3c-ti%E1%BB%81n-ho%C3%A0n-tr%E1%BA%A3',
  'booking_service_name': 'instant',
  'booking_status_description': 'Đã trả hàng',
  'distance': 1360,
  'drop_time': 1732258500,
  'receiver_bill': {
    'total': {
      'raw_value': 0,
      'value': 0,
      'text': '0đ',
    },
    'bill_items': [],
  },
  'assigned_time': 1732257671,
  'receiver_info': {
    'phone': '0028586869',
    'user_contact_id': 0,
    'bill_amount': 0,
    'name': 'Test',
  },
  'booking_type': 2,
  'enroute_status': 2,
  'pick_address_info': {
    'latitude': 10.771984,
    'city_id': 217,
    'district_id': 1,
    'longitude': 106.704391,
    'address': '2 Hải Triều, Phường Bến Nghé, Quận 1, TP. HCM',
  },
  'shipping_fee': {
    'raw_value': 7800.0,
    'value': 7800.0,
    'text': '7.800đ',
  },
  'recipient_labels': [
    '1',
    '1 kg',
  ],
};
const MOCK_SHIP_CUSTOMER_DATA_OLD = {
  // 模拟详情接口返回的骑手定位
  driver_location: MOCK_DRIVER_LOCATION,
  status: 8,
  update_time: 1607052282,
  code: '201204SEIZC6',
  driver: {
    is_deleted: true,
    username: 'tuancv22',
    first_name: 'cao',
    name: 'Cao Tuan Vinh ',
    vehicle_description: 'Lead',
    driver_statistics: {
      started_working_time: 1530489600,
      total_trip: 470,
      average_rate: 4.0,
      total_distance: 1719885,
      rating_reasons: [
        { reason_id: 45, total_rate: 1 },
        { reason_id: 46, total_rate: 2 },
        { reason_id: 47, total_rate: 1 },
        { reason_id: 48, total_rate: 2 },
        { reason_id: 49, total_rate: 2 },
      ],
    },
    license_plate: '49E1-59052',
    avatars: [
      {
        width: 200,
        value:
          'https://down-sp-sg.img.susercontent.com/vn-11134512-7r98o-lvojnz7wxnvrbf',
        height: 200,
      },
    ],
    phone: '0973045291',
    avatar:
      'https://down-sp-sg.img.susercontent.com/vn-11134512-7r98o-lvojnz7wxnvrbf',
    language_code: 'vi',
    device: 4,
  },
  item_value: { raw_value: 0.0, value: 0.0, text: '0d' },
  payment_method: { payment_method_name: 'Cash', payment_method_id: 1 },
  booking_service_type: 2,
  sender_info: {
    phone: '0973045291',
    user_contact_id: 0,
    bill_amount: -106900.0,
    name: 'Tien Nguyen02',
  },
  customer_note: 'This note is as long as the Tale of Kieu by Nguyen Du',
  shipper_id: 29132,
  enroute_status: 1, // 在途状态, 搜索 EnumEnrouteStatus
  pick_real_time: 1607052282, // 预计取件时间
  drop_real_time: 0, // 预计送达时间
  create_time: 1607052232,
  assign_time: 1607052232,
  pick_time: 1607055832,
  drop_time: 1607056792,
  cancel_time: 1607056792,
  returned_time: 1607056792,
  drop_address_info: {
    latitude: 10.778845,
    city_id: 217,
    district_id: 4,
    longitude: 106.717215,
    address:
      '18/7A Luong Dinh Cua Street, An Khanh Ward, District 2, Ho Chi Minh City, Vietnam',
  },
  pick_address_info: {
    latitude: 10.773007,
    city_id: 217,
    district_id: 1,
    longitude: 106.700629,
    address:
      'Saigon Centre, 651A Le Loi Street, Ben Nghe Ward, District 1, Ho Chi Minh City, Vietnam',
  },
  booking_service_name: '4H Delivery',
  receiver_info: {
    phone: '0973045292',
    user_contact_id: 0,
    bill_amount: 0,
    name: 'QA NowShip',
  },
  pick_type: 1,
  distance: 5048,
  sender_bill: {
    total: { raw_value: 106900.0, value: 106900.0, text: '106,900d' },
    bill_items: [
      {
        raw_value: 101000,
        fee_type: 1,
        name: 'Delivery fee (5.0km)',
        value: 101000,
        text: '101,000d',
      },
      {
        raw_value: 5900.0,
        fee_type: 5,
        name: 'Service fee',
        value: 5900.0,
        text: '5,900d',
      },
    ],
  },
  shipping_fee: { raw_value: 106900.0, value: 106900.0, text: '106,900d' },
  recipient_labels: ['Documents', '< 1kg'],
  receiver_bill: {
    total: { raw_value: 0, value: 0, text: '0d' },
    bill_items: [],
  },
  paid_status: 2,
  shipping_fee_origin: { raw_value: 101000, value: 101000, text: '101,000d' },
  item_info: { item_category_id: 3, item_weight: 0 },
  booking_sharing_url: 'https://qashare.test.now.vn/ship/201204SEIZC62659a',
  booking_type: 2,
  shipping_fee_discount: { raw_value: 0, value: 0, text: '0d' },
  return_fee: {
    return_fee_payment_method: 1,
    raw_value: 50500.0,
    value: 50500.0,
    text: '50,500d',
  },
  target_user_type: 1,
  data_by_status: {
    is_share_booking: true,
    expected_times: [
      { name: 'Picked up', time: 1607052282 },
      { name: 'Deliver before', time: 1607056792 },
    ],
    display_statuses: [
      {
        status: 2,
        style_type: 1,
        update_time: 1607052232,
        status_name: 'Order placed',
      },
      {
        status: 3,
        style_type: 2,
        update_time: 1607052282,
        status_name: 'Picked up',
      },
      { status: 4, style_type: 1, status_name: 'Completed' },
    ],
    is_chat_accessible: true,
    is_user_cancel: false,
    is_end_status: false,
    heading_status: 'Driver is arriving at delivery location...',
    is_feedback: false,
    is_report: false,
    is_pickup_help: false,
  },
  assigning_timeout_time: 1607052472,
};
const MOCK_SHIP_CUSTOMER_RETURN_FAILED = {
  'code': '241219SIJMR1',
  'payment_method': {
    'payment_method_name': 'Tiền mặt',
    'payment_method_id': 1,
  },
  'booking_service_type': 1,
  'customer_note': '',
  'create_time': 1734579863,
  'pick_time': 1734580500,
  'promotion_code': {
    'note': '',
    'update_time': 1733712229,
    'code': 'ZZYUAT0001',
    'title': '',
    'is_active': 1,
    'start_time': 1733715720,
    'timeranges': '',
    'title_en': '',
    'target_type': 0,
    'auto_apply': 1,
    'priority': 0,
    'conditions': '{"promotion_type":2,"booking_condition":{"booking_type":2,"booking_service_type":1},"terms_of_use":{"terms_of_use_vi":"","terms_of_use_en":""},"tags":{"tags_vi":[],"tags_en":[]}}',
    'create_time': 1733712229,
    'end_time': 1738294920,
    'remaining_quantity': 9886,
    'quantity': 10000,
    'discount_data': '{"max_discount_value":10000,"discount_value_type":1,"discount_value":10000}',
    'id': 234664,
    'is_displayed_on_checkout': 0,
  },
  'pick_real_time': 1734579985,
  'return_time': null,
  'pick_type': 1,
  'item_value': {
    'raw_value': 0.0,
    'value': 0.0,
    'text': '0đ',
  },
  'sender_bill': {
    'total': {
      'raw_value': 55850.0,
      'value': 55850.0,
      'text': '55.850đ',
    },
    'bill_items': [
      {
        'raw_value': 64650.0,
        'fee_type': 1,
        'name': 'Phí giao hàng (9.3km)',
        'value': 64650.0,
        'text': '64.650đ',
      },
      {
        'raw_value': 1200,
        'description': 'Phí dịch vụ được áp dụng trên đơn để giúp ShopeeFood tiếp tục cải thiện dịch vụ và mang lại cho khách hàng trải nghiệm tốt nhất!',
        'text': '1.200đ',
        'value': 1200,
        'fee_type': 5,
        'name': 'Phí dịch vụ',
      },
      {
        'raw_value': -10000,
        'fee_type': 2,
        'name': 'Khuyến mãi (ZZYUAT0001)',
        'value': -10000,
        'text': '-10.000đ',
      },
    ],
  },
  'paid_status': 1,
  'shipping_fee_origin': {
    'raw_value': 64647.0,
    'value': 65000.0,
    'text': '65.000đ',
  },
  'item_info': {
    'item_category_id': 7,
    'item_weight': 1,
    'dimension': {
      'width': 20,
      'length': 20,
      'height': 20,
    },
    'size': 1,
  },
  'shipping_fee_discount': {
    'raw_value': 10000,
    'value': 10000,
    'text': '10.000đ',
  },
  'return_fee': {
    'return_fee_payment_method': 1,
    'raw_value': 51350.0,
    'value': 51350.0,
    'text': '51.350đ',
  },
  'drop_real_time': 1734579990,
  'target_user_type': 1,
  'data_by_status': {
    'is_share_booking': false,
    'is_report': false,
    'cancel_reason': '<b>Lý do trả hàng: </b>Không thể giao hàng cho người nhận.',
    'is_user_cancel': false,
    'is_refund': false,
    'display_statuses': [
      {
        'status': 2,
        'style_type': 1,
        'update_time': 1734579863,
        'is_expected_time': false,
        'status_name': 'Đặt đơn',
      },
      {
        'status': 3,
        'style_type': 1,
        'update_time': 1734579985,
        'is_expected_time': false,
        'status_name': 'Đã lấy',
      },
      {
        'status': 5,
        'style_type': 3,
        'update_time': 1734579990,
        'is_expected_time': false,
        'status_name': 'Đã hủy',
      },
    ],
    'is_chat_accessible': false,
    'heading_status': 'Đơn hàng hủy',
    'is_end_status': true,
    'expected_times': [
      {
        'style_type': 1,
        'is_expected_time': false,
        'name': 'Đã lấy',
        'time': 1734579985,
      },
      {
        'style_type': 1,
        'is_expected_time': true,
        'name': 'Đã huỷ đơn lúc',
        'time': 1734579990,
      },
    ],
    'is_pickup_help': false,
    'system_note': 'Lưu ý: Đơn hàng đã được trả hàng về kho. Để lấy lại hàng, vui lòng liên lạc số hotline 1900 2042.',
    'is_feedback': true,
  },
  'assigning_timeout_time': 1734580223,
  'status': 15,
  'cancel_time': null,
  'update_time': 1734579990,
  'sender_info': {
    'phone': '+002024121901',
    'user_contact_id': 0,
    'bill_amount': -55850.0,
    'name': 'foodee_7lte9sya',
  },
  'booking_sharing_url': 'https://share.uat.shopeefood.vn/ship/241219SIJMR1e1c95',
  'drop_address_info': {
    'latitude': 10.796795,
    'city_id': 217,
    'district_id': 4,
    'longitude': 106.758849,
    'address': 'Quan 2, Ho Chi Minh City, Vietnam',
  },
  'driver': {
    'username': 'bj fu25 7700',
    'last_name': 'bj',
    'uid': 74546,
    'type_id': 3,
    'city_id': 217,
    'driver_statistics': {
      'started_working_time': 1648166400,
      'total_trip': 257,
      'average_rate': 4.8,
      'total_distance': 3339323,
      'rating_reasons': [
        {
          'reason_id': 46,
          'total_rate': 13,
        },
        {
          'reason_id': 162,
          'total_rate': 5,
        },
        {
          'reason_id': 163,
          'total_rate': 9,
        },
        {
          'reason_id': 164,
          'total_rate': 8,
        },
      ],
    },
    'license_plate': '67H5-6840',
    'created_time': '2022-03-25 09:47:47',
    'avatar_mms_img_id': 'vn-11134521-7r98o-lun1if9baddke0',
    'full_name': 'bj fu25 7700',
    'skype': '',
    'max_order_handle': 6,
    'first_name': 'fu25',
    'display_name': 'bj fu25 7700',
    'personal_email': '20220325@qq.com',
    'work_status_id': 1,
    'secondary_phone': '',
    'other_phones': [],
    'email': '20220325@qq.com',
    'status': 1,
    'vehicle_description': 'Honda Airblade',
    'image_name': 'vn-11134521-7r98o-lun1if9baddke0',
    'group_service': 1,
    'phone': '0088007700',
    'is_online': true,
    'working_city_id': 217,
    'begin_work_date': '2022-03-25 00:00:00',
    'is_deleted': false,
    'name': 'bj fu25 7700',
    'avatars': [
      {
        'width': 200,
        'value': 'https://down-ws-vn.img.susercontent.com/vn-11134521-7r98o-lun1if9baddke0',
        'height': 200,
      },
    ],
    'avatar_url': 'https://down-ws-vn.img.susercontent.com/vn-11134521-7r98o-lun1if9baddke0',
    'avatar': 'https://down-ws-vn.img.susercontent.com/vn-11134521-7r98o-lun1if9baddke0',
  },
  'shipper_id': 74546,
  'help_center_url': 'https://help.shopeefood.vn/s/article/Khi-n%C3%A0o-t%C3%B4i-nh%E1%BA%ADn-%C4%91%C6%B0%E1%BB%A3c-ti%E1%BB%81n-ho%C3%A0n-tr%E1%BA%A3',
  'booking_service_name': 'Giao Siêu Tốc ',
  'booking_status_description': 'Đã hủy đơn',
  'distance': 9325,
  'drop_time': 1734586500,
  'receiver_bill': {
    'total': {
      'raw_value': 0,
      'value': 0,
      'text': '0đ',
    },
    'bill_items': [],
  },
  'assigned_time': 1734579974,
  'receiver_info': {
    'phone': '+002024121901',
    'user_contact_id': 0,
    'bill_amount': 0,
    'name': 'foodee_7lte9sya',
  },
  'booking_type': 2,
  'enroute_status': 2,
  'pick_address_info': {
    'latitude': 10.771984,
    'city_id': 217,
    'district_id': 1,
    'longitude': 106.704391,
    'address': '2 Hải Triều, Phường Bến Nghé, Quận 1, TP. HCM',
  },
  'shipping_fee': {
    'raw_value': 55850.0,
    'value': 55850.0,
    'text': '55.850đ',
  },
  'recipient_labels': [
    'Text nay dai 20 kitu',
    '1 kg',
  ],
};
export const MOCK_SHIP_CUSTOMER_DATA = MOCK_SHIP_CUSTOMER_RETURN_FAILED;
export const MOCK_SHIP_SHOPEE_DATA = {
  // 模拟详情接口返回的骑手定位
  driver_location: MOCK_DRIVER_LOCATION,
  status: 8,
  update_time: 1607052282,
  code: '201204SEIZC6',
  driver: {
    is_deleted: true,
    username: 'tuancv22',
    first_name: 'cao',
    name: 'Cao Tuan Vinh ',
    vehicle_description: 'Lead',
    driver_statistics: {
      started_working_time: 1530489600,
      total_trip: 470,
      average_rate: 4.0,
      total_distance: 1719885,
      rating_reasons: [
        { reason_id: 45, total_rate: 1 },
        { reason_id: 46, total_rate: 2 },
        { reason_id: 47, total_rate: 1 },
        { reason_id: 48, total_rate: 2 },
        { reason_id: 49, total_rate: 2 },
      ],
    },
    license_plate: '49E1-59052',
    avatars: [
      {
        width: 200,
        value:
          'https://down-sp-sg.img.susercontent.com/vn-11134512-7r98o-lvojnz7wxnvrbf',
        height: 200,
      },
    ],
    phone: '0973045291',
    avatar:
      'https://down-sp-sg.img.susercontent.com/vn-11134512-7r98o-lvojnz7wxnvrbf',
    language_code: 'vi',
    device: 4,
  },
  drop_address_info: {
    latitude: 10.778845,
    city_id: 217,
    district_id: 4,
    longitude: 106.717215,
    address:
      '18/7A Luong Dinh Cua Street, An Khanh Ward, District 2, Ho Chi Minh City, Vietnam',
  },
  item_value: { raw_value: 0.0, value: 0.0, text: '0d' },
  payment_method: { payment_method_name: 'Cash', payment_method_id: 1 },
  booking_service_type: 2,
  sender_info: {
    phone: '0973045291',
    user_contact_id: 0,
    bill_amount: -106900.0,
    name: 'Tien Nguyen02',
  },
  drop_time: 1607056792,
  customer_note: 'This note is as long as the Tale of Kieu by Nguyen Du',
  shipper_id: 29132,
  pick_address_info: {
    latitude: 10.773007,
    city_id: 217,
    district_id: 1,
    longitude: 106.700629,
    address:
      'Saigon Centre, 651A Le Loi Street, Ben Nghe Ward, District 1, Ho Chi Minh City, Vietnam',
  },
  create_time: 1607052232,
  booking_service_name: '4H Delivery',
  pick_time: 1607055832,
  receiver_info: {
    phone: '0973045292',
    user_contact_id: 0,
    bill_amount: 0,
    name: 'QA NowShip',
  },
  pick_real_time: 1607052282,
  pick_type: 1,
  distance: 5048,
  sender_bill: {
    total: { raw_value: 106900.0, value: 106900.0, text: '106,900d' },
    bill_items: [
      {
        raw_value: 101000,
        fee_type: 1,
        name: 'Delivery fee (5.0km)',
        value: 101000,
        text: '101,000d',
      },
      {
        raw_value: 5900.0,
        fee_type: 5,
        name: 'Service fee',
        value: 5900.0,
        text: '5,900d',
      },
    ],
  },
  shipping_fee: { raw_value: 106900.0, value: 106900.0, text: '106,900d' },
  recipient_labels: ['Documents', '< 1kg'],
  receiver_bill: {
    total: { raw_value: 0, value: 0, text: '0d' },
    bill_items: [],
  },
  paid_status: 2,
  shipping_fee_origin: { raw_value: 101000, value: 101000, text: '101,000d' },
  item_info: { item_category_id: 3, item_weight: 0 },
  booking_sharing_url: 'https://qashare.test.now.vn/ship/201204SEIZC62659a',
  booking_type: 4,
  shipping_fee_discount: { raw_value: 0, value: 0, text: '0d' },
  return_fee: {
    return_fee_payment_method: 1,
    raw_value: 50500.0,
    value: 50500.0,
    text: '50,500d',
  },
  drop_real_time: 0,
  target_user_type: 1,
  data_by_status: {
    is_share_booking: true,
    expected_times: [
      { name: 'Picked up', time: 1607052282 },
      { name: 'Deliver before', time: 1607056792 },
    ],
    display_statuses: [
      {
        status: 2,
        style_type: 1,
        update_time: 1607052232,
        status_name: 'Order placed',
      },
      {
        status: 3,
        style_type: 2,
        update_time: 1607052282,
        status_name: 'Picked up',
      },
      { status: 4, style_type: 1, status_name: 'Completed' },
    ],
    is_chat_accessible: true,
    is_user_cancel: false,
    is_end_status: false,
    heading_status: 'Driver is arriving at delivery location...',
    is_feedback: false,
    is_report: false,
    is_pickup_help: false,
  },
  assigning_timeout_time: 1607052472,
};
